import { render } from "./SelectPathologies.vue?vue&type=template&id=3cf71fbc&scoped=true"
import script from "./SelectPathologies.vue?vue&type=script&lang=js"
export * from "./SelectPathologies.vue?vue&type=script&lang=js"

import "./SelectPathologies.vue?vue&type=style&index=0&id=3cf71fbc&lang=less&scoped=true"

import exportComponent from "/u01/sourcecode/portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cf71fbc"]])

export default __exports__